export default __webpack_public_path__ + "static/media/login-background.ffb641af.svg";